// extracted by mini-css-extract-plugin
export var details = "project-details-module--details--1tNzN";
export var eyebrow = "project-details-module--eyebrow--3x_0h";
export var stack = "project-details-module--stack--1M9nh";
export var featured = "project-details-module--featured--3OUDF";
export var html = "project-details-module--html--3YwDw";